import React, { useEffect, useRef, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from '../../../common/table/agGrid/AgGridCommon';
import styled from 'styled-components';
import { common } from '../../../utils/agGrid/options';
import { CORE_FILES } from 'reducers/coreFilesReducer';
import { useAppSelector } from 'hooks/useAppSelector';
import { createLoadingSelector } from 'erisxkit/client';

interface CoreFile {
  taskId: string;
  state: string;
  value: string;
}

interface ExportCoreFileGridProps {
  data: CoreFile[];
  colDefs: ColDef[];
}

const StyledAgGridContainer = styled.div`
  height: 350px;
  ag-root-wrapper {
    height: 100% !important;
  }
`;

export const gridName = 'export-core-file';

const ExportCoreFileGrid: React.FC<ExportCoreFileGridProps> = ({
  data,
  colDefs,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<CoreFile[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
   const loading = useAppSelector((state) =>
     createLoadingSelector([CORE_FILES])(state),
   );
  ;
  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName,
  });

  useEffect(() => {
    setRowData(data);
    if (!initialGridSettings?.columnSizing) {
      gridRef.current?.api?.sizeColumnsToFit();
    }
  }, [data, initialGridSettings?.columnSizing]);

  return (
    <StyledAgGridContainer className="ag-theme-quartz">
      {gridVisible && (
        <AgGridReact
          loading={loading}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          gridOptions={common}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
        />
      )}
    </StyledAgGridContainer>
  );
};

export default ExportCoreFileGrid;
